<template>
  <div>
    <v-container class="grey lighten-5">
      <v-row no-gutters class="pagination-table-header">
        <v-col
          col="12"
        >
          <v-overlay
            :absolute="true"
            :value="isComponentLoading"
          >
            <v-progress-circular indeterminate size="24"></v-progress-circular>
          </v-overlay>
          <v-card
            v-if="L.isEmpty(paginatedObject) || L.isEmpty(paginatedObject.data)"
            class="pa-3">
            <p class="text-center mt-2">
              <v-icon>mdi-account-search-outline</v-icon>
              <b>&nbsp;&nbsp;{{ lang($store, 'sap/listings.not_found') }}&nbsp;&nbsp;</b>
              <v-icon>mdi-account-badge-outline</v-icon>
            </p>
          </v-card>
          <div v-else>
            <v-row>
              <v-col
                v-for="(item, key) in paginatedObject.data"
                :key="'col_' + key"
                cols="12" lg="3"
                md="4" sm="6"
                class="py-1"
              >
                <v-card
                  class="pa-1"
                  :style="{
                  background: (!!(item.status === OPEN)?'#fe555594':'#7bffac')
                  }"
                >
                  <div>
                    <div style="display: none">{{ item.uuid }}</div>
                    <contact-line
                      v-if="item.order && item.order.contact"
                      :contact="item.order.contact"/>
                    <v-divider/>

                    <cleaner-line
                      v-if="item.order && item.order.foreman"
                      :cleaner="item.order.foreman"
                      :not-found-text="lang($store, 'sap/listings.orders.foreman_not_set')"
                    />
                    <cleaners-line
                      v-else-if="item.order && item.order.cleaners"
                      :cleaners="item.order.cleaners"/>
                    <v-divider/>
                    <div class="d-flex flex-row">
                      <datetime-alert
                        v-if="item.order &&  item.order.datetime"
                        :datetime="moment(item.order.datetime)"
                      />
                      <router-link :to="{ name: 'damages.show', params: { damageUuid: item.uuid }}">
                        <v-icon small>mdi-briefcase-edit-outline</v-icon>
                      </router-link>
                      <trash-button @click="onItemDelete(item)"/>
                      <comment-input
                        :value="item.minicomment"
                        :update-request="updateSimpleRequest(item, 'minicomment')"
                        @updated:text="item.minicomment = $event; $forceUpdate()"
                      />
                    </div>
                    <div>
                      <comment-input
                        class="w-100"
                        :value="item.minicomment2"
                        :update-request="updateSimpleRequest(item, 'minicomment2')"
                        @updated:text="item.minicomment2 = $event; $forceUpdate()"
                      />
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
/* proxies */
import DamageProxy from '@/proxies/Damage/DamageProxy';
/* constants */
import { OPEN } from '@/constants/damage_statuses';
/* utils */
import { roles as rolesColors } from '@/utils/listingColors';
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
import orderUpdateSimpleProp from '@/mixins/orders/orderUpdateSimpleProp';
/* components */
import CommentInput from '@/components/minialerts/CommentInput.vue';
import DatetimeAlert from '@/components/minialerts/DatetimeAlert.vue';
import ContactLine from '@/components/minialerts/ContactLine.vue';
import TrashButton from '@/components/minialerts/TrashButton.vue';
import CleanersLine from '@/components/minialerts/CleanersLine.vue';
import CleanerLine from '@/components/minialerts/CleanerLine.vue';


export default {
  name: 'TablePaginatedDamages',
  components: {
    DatetimeAlert,
    ContactLine,
    TrashButton,
    CleanersLine,
    CleanerLine,
    CommentInput,
  },
  mixins: [isComponentLoading, orderUpdateSimpleProp],
  props: {
    paginatedObject: {
      type: Object,
      default: () => {
      },
    },
    noActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      moment,
      rolesColors,
      OPEN,
      L: _,
    };
  },
  computed: {
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    cardColor(item) {
      return 'white';
    },
    onItemEdit(item) {
      this.$emit('edit-item', item);
    },
    onItemDelete(item) {
      this.$emit('delete-item', item);
    },
    onItemCopy(item) {
      this.$emit('copy-item', item);
    },
    onPreview(item) {
      this.$emit('preview-item', item);
    },

    onAddressEdit(item, address) {
      this.$emit('edit-address', {
        item,
        address,
      });
    },
    onAddressDelete(item, address) {
      this.$emit('delete-address', {
        item,
        address,
      });
    },
    getUpdateSimpleRequestClient() {
      return new DamageProxy();
    },
  },
};
</script>

<style lang="sass" scoped>
.table-action
  &:hover
    fill: #0066ff
    transition: fill 0.5s
    cursor: pointer
</style>
